import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

const HandGestureIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="quu2hm0j3a">
          <stop stop-color="#3E8BFF" offset="0%" />
          <stop stop-color="#3E8BFF" offset="100%" />
        </linearGradient>
      </defs>
      <path
        d="M11.667 1.292a2.27 2.27 0 0 1 2.271 2.27l-.003 5.478 1.363.37-.399 1.462-2.475-.675V3.563a.757.757 0 1 0-1.514 0v14.382H9.397v-5.299a2.27 2.27 0 0 0-2.271 2.27v3.52l3.027 3.784V24H8.64v-1.248l-3.028-3.785v-4.05a3.79 3.79 0 0 1 3.785-3.785v-7.57a2.27 2.27 0 0 1 2.27-2.27zm-3.784.757v1.514H6.369V2.049h1.514zm9.937 9.623-1.46-.398.398-1.46 1.46.397-.398 1.461zm1.461.394 1.47.401v6.74l-2.271 3.027V24h1.514v-1.262l2.27-3.028v-8.4l-2.585-.704-.398 1.46zM3.876 1.07 2.806 0 0 2.806l2.806 2.806 1.07-1.07-.978-.98h1.957V2.05H2.898l.978-.979zm15.582 3.472 1.07 1.07 2.807-2.806L20.529 0l-1.07 1.07.978.979H18.48v1.514h1.957l-.979.979zm-4.006-2.493h1.514v1.514h-1.514z"
        fillRule="nonzero"
        fill={`${props.fill || 'url(#u771hwde5a)'}`}
      />
    </SvgIcon>
  );
};

export default HandGestureIcon;
